import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';

import PropTypes from 'prop-types';

import { get } from 'lodash';

import { Spinner } from '~/components';

import { Container } from './styles';

import { closeDialog } from '~/store/modules/dialog/actions';


export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();
  //  const { usuarioacesso } = useSelector((state) => state.user);


  function openWin(url) {
    //const myWindow = window.open(url, "myWindow", "fullscreen");   // Opens a new window
    //window.open(url, "myWindow", "fullscreen");   // Opens a new window
    window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=1,left=1, fullscreen");
  }

  const { loading, find, params } = useSelector(
    (state) => state.operacaoradpesquisaprefaturagfo
  );

  const initials = create ? data : { ...find, ...data };


  async function handleSubmit(param) {
    try {
      const cosi_url_aplic_rel_rad_getPDF = get(initials, 'cosi_url_aplic_rel_rad_getPDF', '');
      openWin(cosi_url_aplic_rel_rad_getPDF);
      dispatch(closeDialog());
    } catch (err) {
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!loading) {
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [loading, initials]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (create) {
      } else {
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [find]);


  return (
    <Container>

      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
          <>
            <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
              <p>Clique no botão confirma para abrir. </p>
            </Form>
          </>
        )
      }

    </Container >
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
